import { createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH } from '../../constant';

export interface Payload {
  email: string;
}

export const multipleHospitalsApi = createAsyncThunk('multipleHospitals', async (payload: Payload, { rejectWithValue }) => {
  try {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };
    let res = await fetch(AUTH.MULTIPLE_HOSPITALS, requestOptions);
    const data = await res.json();

    if (!res.ok) {
        return rejectWithValue(data);
    }

    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
